// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3K3tR","question":"Question_question__Sz4Qb","description":"Question_description__G9yl6"};